import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, MessageSquare, Calculator } from 'lucide-react';

const MobileNav = () => {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const navItems = [
    {
      path: '/',
      icon: Home,
      label: 'Accueil'
    },
    {
      path: '/simulateur',
      icon: Calculator,
      label: 'Simulateur',
      highlighted: true
    },
    {
      path: '/contact',
      icon: MessageSquare,
      label: 'Contact'
    }
  ];

  return (
    <nav 
      className="md:hidden fixed bottom-0 left-0 right-0 z-[100]"
      style={{ 
        background: 'rgba(10, 10, 12, 0.95)',
        backdropFilter: 'blur(12px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)'
      }}
      data-testid="mobile-nav"
    >
      <div className="flex items-center justify-around h-16 px-4">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);

          if (item.highlighted) {
            return (
              <Link
                key={item.path}
                to={item.path}
                className="relative flex flex-col items-center justify-center -mt-6"
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              >
                <div 
                  className="flex items-center justify-center w-14 h-14 rounded-full transition-all duration-300 hover:scale-110"
                  style={{ 
                    background: active ? '#00cec9' : 'linear-gradient(135deg, #6c5ce7 0%, #00cec9 100%)',
                    boxShadow: '0 4px 20px rgba(0, 206, 201, 0.4)'
                  }}
                >
                  <Icon 
                    size={24} 
                    className="text-black"
                    strokeWidth={2.5}
                  />
                </div>
                <span 
                  className="text-xs mt-1 font-medium"
                  style={{ color: active ? '#00cec9' : 'rgba(255, 255, 255, 0.7)' }}
                >
                  {item.label}
                </span>
              </Link>
            );
          }

          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center py-2 px-4 transition-all duration-300"
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              <div 
                className="p-2 rounded-lg transition-all duration-300"
                style={{ 
                  background: active ? 'rgba(0, 206, 201, 0.1)' : 'transparent'
                }}
              >
                <Icon 
                  size={22} 
                  style={{ color: active ? '#00cec9' : 'rgba(255, 255, 255, 0.5)' }}
                />
              </div>
              <span 
                className="text-xs mt-1"
                style={{ color: active ? '#00cec9' : 'rgba(255, 255, 255, 0.5)' }}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
